import axios from "axios";
import transactionEnquiryTypes from "../actions/types/transactionEnquiry.action.type";
import store from "../store/index";
import { listProps, getExceptionMessage, API_BASE_URL, formatDateTime } from "../utils/helper";
import axiosRetry from 'axios-retry';
import { processResponse } from "./serviceUtil";
import { FI } from "../constants/sharedConstants.js";
import { t } from "i18next";
import services from "./index.js";
import { ACTION_TYPES } from "./serviceLevelMonitoring.service.js";

export const transactionEnquiryService = {
  getTransactionEnquiry,
  getTransactionsForReject,
  rejectTransaction,
  searchRecallPendingApprovals,
  processPendingApproval,
  recallTransaction,
  searchRecallRejectHistory
};

function getTransactionEnquiry(transactionData, props) {

  const requestStartTime = new Date(
    performance.timeOrigin + performance.now()
  ).toISOString();
  
//console.log("TE.SVC - getTransactionEnquiry - txnData: " + listProps(transactionData, true));
  return (dispatch) => {
    const user = store.getState()?.loginUserReducer.user;
    const fiDetail = store.getState()?.fiReducer;
    const token = store.getState()?.loginUserReducer.token;

    axiosRetry(axios, {
      retries: 5,
      retryDelay: (retryCount) => {
        return retryCount * (retryCount < 2 ? 20000 : 30000); // time interval between retries
      },
      retryCondition: (error) => {
        return error.response.status === 504;
      },
      onRetry: (retryCount, error, requestConfig) => {
        const requestId = error?.response?.data?.error?.split("::")[0]?.trim();
        requestConfig.data = requestConfig.data?.replace('"requestId":null', `"requestId":"${requestId}"`);

        if (props?.setErrorMessage) {
          let errMsg = t("erps.transactionEnquiry.page.pending");
          if (error?.response?.data?.timestamp)
            errMsg += "  [" + error.response.data.timestamp + "]";
          errMsg += "  (attempt " + retryCount + (requestId ? ";  requestId: " + requestId : "") + ")";
          props.setErrorMessage(errMsg);
        }
      }
    });

    const { startOffset, endOffset, paymentFromDate, paymentToDate, ...rest } = transactionData;

    let isOLD = (transactionData.updated_by == "OLD");    // THE OLD TransactionEnquiry - TO BE REMOVED
    let request;
    if (isOLD) {  // THE OLD TransactionEnquiry - TO BE REMOVED
      request = { ...rest,
                  paymentFromDate: formatDateTime(paymentFromDate, "YYYYMMDD"),
                  paymentToDate: formatDateTime(paymentToDate, "YYYYMMDD"),
                  fiNumber: props?.fiNumberValue,
                  selectedFiNumber: fiDetail?.selectedFi,
                  // fiCompanyNumber: transactionData?.subscribeEntityId
                  //   ? transactionData.subscribeEntityId
                  //   : user.fiCompanyNumber,
                  offset: startOffset,
                  limit: 100,
                  userId: user.userId,
                  languageCode: user.languageCode,
                  roleType: user?.role?.role_type,
                  requestId: null,
                  requestFrom:"reviewTransactions"
                };
    } else {
      request = { ...transactionData,
                  userId: user.userId,
                  languageCode: user.languageCode,
                  roleType: user?.role?.role_type,
                  requestId: null,
                  requestFrom:"reviewTransactions"
                };
    }
    if (user.fiNumber == FI.CTB_BILLER && user.billerCrossReferenceDto)
      request.ctbId = user.billerCrossReferenceDto.centralizedBillerId;
    // we only set fiCompanyNumber if it's not empty and not "0"
    let fiCompanyNumber = transactionData?.subscribeEntityId || user.fiCompanyNumber;
    if (fiCompanyNumber && fiCompanyNumber != "0")
      request.fiCompanyNumber = fiCompanyNumber;
//console.log("TE.SVC - getTransactionEnquiry - " + (transactionData.updated_by || "NEW") + " request: " + listProps(request, true));

    axios
      .post(
        `${API_BASE_URL()}/searchTransaction`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        const response = 
        isOLD ? // THE OLD TransactionEnquiry - TO BE REMOVED
        {
          data: res.data,
          transactionEnquiryDetails: {
            ...transactionData,
            paymentFromDate,
            paymentToDate,
          }
        }
        :
        {  // THIS IS THE NEW RESPONSE - TO REMAIN
          data: res.data,
          transactionEnquiryDetails: { ...transactionData }
        };
        dispatch( {data: response,  type: transactionEnquiryTypes.GET_TRANSACTION_ENQUIRY_SUCCESS} );
        processResponse(true, props);

        const requestEndTime = new Date(
          performance.timeOrigin + performance.now()
        ).toISOString();

        services.serviceLevelMonitoringService.recordData({
          actionType: ACTION_TYPES.TRANSACTION_SEARCH,
          fiNumber: transactionData?.currentFiNumber,
          loggedInUserId: user.userId,
          requestStartTime,
          requestEndTime,
          requestParams: JSON.stringify(transactionData)
        });
      })
      .catch((error) => {
        let errorObject = getExceptionMessage(error);
        dispatch( {error: errorObject,  type: transactionEnquiryTypes.GET_TRANSACTION_ENQUIRY_ERROR} );
        processResponse(false, props, errorObject);
      });
  };
}

function getTransactionsForReject(transactionData, props) {
  return (dispatch) => {
    const user = store.getState()?.loginUserReducer.user;
    const token = store.getState()?.loginUserReducer.token;

    axiosRetry(axios, {
      retries: 5,
      retryDelay: (retryCount) => {
        return retryCount * (retryCount < 2 ? 20000 : 30000); // time interval between retries
      },
      retryCondition: (error) => {
        return error.response.status === 504;
      },
      onRetry: (retryCount, error, requestConfig) => {
        const requestId = error?.response?.data?.error?.split("::")[0]?.trim();
        requestConfig.data = requestConfig.data?.replace('"requestId":null', `"requestId":"${requestId}"`);

        if (props?.setErrorMessage && props?.t) {
          let errMsg = props?.t("erps.transactionEnquiry.page.pending");
          if (error?.response?.data?.timestamp)
            errMsg += "  [" + error.response.data.timestamp + "]";
          errMsg += "  (attempt " + retryCount + (requestId ? ";  requestId: " + requestId : "") + ")";
          props.setErrorMessage(errMsg);
        }
      }
    });
    const request = {
          userId: user.userId,
          roleType: user?.role?.role_type,
          languageCode: user.languageCode,
          //requestId: null,     //MB:  What is it for ??
          requestFrom:"rejectPaymentForMerchants",
            fiCompanyNumber: user?.fiCompanyNumber || transactionData?.subscribeEntityId,
          ...transactionData
        };
    if (user.fiNumber == FI.CTB_BILLER && user.billerCrossReferenceDto)
      request.ctbId = user.billerCrossReferenceDto.centralizedBillerId;
    axios
      .post(
        `${API_BASE_URL()}/search-transactions-for-reject`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        const response = {
          data: res.data,
          transactionForRejectDetails: { ...transactionData },
        };
        dispatch( {data: response,  type: transactionEnquiryTypes.GET_TRANSACTION_FOR_REJECT_SUCCESS} );
        processResponse(true, props);
      })
      .catch((error) => {
        let errorMessage = getExceptionMessage(error);
        dispatch( {error: errorMessage,  type: transactionEnquiryTypes.GET_TRANSACTION_FOR_REJECT_FAILURE} );
        processResponse(false, props, errorMessage);
      });
  };
}

function searchRecallPendingApprovals(transactionData, props) {
//console.log("TE-SVC - searchRecallPendingApprovals - request: " + listProps(transactionData, true));
  return (dispatch) => {
      const user = store.getState()?.loginUserReducer.user;
      //const fiDetail = store.getState()?.fiReducer;
      const token = store.getState()?.loginUserReducer.token;
      const request = {   userId: user.userId,
              languageCode: user.languageCode,
              roleType: user?.role?.role_type,
              fiCompanyNumber: user?.fiCompanyNumber,
              ...transactionData
          };
      if (user.fiNumber == FI.CTB_BILLER && user.billerCrossReferenceDto)
        request.ctbId = user.billerCrossReferenceDto.centralizedBillerId;
      axios
        .post(
          `${API_BASE_URL()}/searchRecallPendingApprovals`,
          request,
          { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, } }
        )
        .then((res) => {
          const response = {
              data: res.data,
              recallPendingApprovalsDetails: { ...transactionData },
          };
          dispatch( {data: response,  type: "GET_RECALL_PENDING_APPROVALS_SUCCESS"} );
          processResponse(true, props);
        })
        .catch((error) => {
          let errorMessage = getExceptionMessage(error);
          dispatch( {error: errorMessage,  type: "GET_RECALL_PENDING_APPROVALS_ERROR"} );
          processResponse(false, props, errorMessage);
        });
  };
}

function processPendingApproval(data, props) {

  return (dispatch) => {
    const user = store.getState()?.loginUserReducer.user;
    const token = store.getState()?.loginUserReducer.token;
    let url = null;
    if (data.action === "C")
      url = `${API_BASE_URL()}/cancel-transaction`;
    else if (data.action === "A")
      url = `${API_BASE_URL()}/approvePendingRecall`;
    else if (data.action === "R")
      url = `${API_BASE_URL()}/rejectPendingRecall`;
    else if (data.action === "RA")
        url = `${API_BASE_URL()}/recallRejectedRecall`;
    else
      console.error("Unrecognized value of data.action: " + data.action);

    axios
      .post(
          url,
          { ...data, language_code: user.languageCode, recalled_rejected_by: user.userId },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
      ).then((res) => {
        dispatch( {data: res.data,  type: transactionEnquiryTypes.UPDATE_TRANSACTION_FOR_PENDING_APPROVAL_SUCCESS} );
        processResponse(true, props);
      }).catch((error) => {
        let errorMessage = getExceptionMessage(error);
        dispatch( {error: errorMessage,  type: transactionEnquiryTypes.UPDATE_TRANSACTION_FOR_PENDING_APPROVAL_FAILURE} );
        processResponse(false, props, errorMessage);
      });
  };
}

function rejectTransaction(data, props) {

  return (dispatch) => {
    const { reqBodyForReject } = data;
    const user = store.getState()?.loginUserReducer.user;
    const token = store.getState()?.loginUserReducer.token;
    axios
        .post(
            `${API_BASE_URL()}/reject-transaction`,
            { ...reqBodyForReject },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
        ).then((res) => {
          const successMsg = t("erps.rejectpaymentmerchants.message.rejectSuccess");
          dispatch( {data: successMsg,  type: transactionEnquiryTypes.UPDATE_TRANSACTION_FOR_REJECT_SUCCESS} );
          processResponse(true, props);
        }).catch((error) => {
          let errorMessage = getExceptionMessage(error);
          dispatch( {error: errorMessage,  type: transactionEnquiryTypes.UPDATE_TRANSACTION_FOR_REJECT_FAILURE} );
          processResponse(false, props, errorMessage);
        });
  };
}

function recallTransaction(data, props) {

  return (dispatch) => {
    const { reqBodyForRecall } = data;
    const user = store.getState()?.loginUserReducer.user;
    const token = store.getState()?.loginUserReducer.token;
    axios
      .post(
          `${API_BASE_URL()}/recall-transaction`,
          { ...reqBodyForRecall },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
      ).then((res) => {
        const successMsg = t("erps.recallpaymentcustomers.message.recallSuccess");
        dispatch( {data: successMsg, type: transactionEnquiryTypes.UPDATE_TRANSACTION_FOR_RECALL_SUCCESS} );
        processResponse(true, props);
      }).catch((error) => {
        let errorMessage = getExceptionMessage(error);
        dispatch( {error: errorMessage,  type: transactionEnquiryTypes.UPDATE_TRANSACTION_FOR_RECALL_FAILURE} );
        processResponse(false, props, errorMessage);
      });
  };
}

function searchRecallRejectHistory(transactionData, props) {
  return (dispatch) => {
    const user = store.getState()?.loginUserReducer.user;
    const fiDetail = store.getState()?.fiReducer;
    const token = store.getState()?.loginUserReducer.token;

    const request = { userId: user.userId,
          languageCode: user.languageCode,
          roleType: user?.role?.role_type,
            fiCompanyNumber: user?.fiCompanyNumber,
          ...transactionData
        };
    if (user.fiNumber == FI.CTB_BILLER && user.billerCrossReferenceDto)
      request.ctbId = user.billerCrossReferenceDto.centralizedBillerId;
    axios
      .post(
        `${API_BASE_URL()}/searchRecallRejectHistory`,
        request,
        { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, } }
      )
      .then((res) => {
        const response = {
          data: res.data,
          recallRejectHistoryDetails: { ...transactionData },
        };
        dispatch( {data: response,  type: "GET_RECALL_REJECT_HISTORY_SUCCESS"} );
        processResponse(true, props);
      })
      .catch((error) => {
        let errorMessage = getExceptionMessage(error);
        dispatch( {error: errorMessage,  type: "GET_RECALL_REJECT_HISTORY_ERROR"} );
        processResponse(false, props, errorMessage);
      });
  };
}
